// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__lP8IR","selected":"Chip_selected__3WJYF"};